import { observer } from 'mobx-react-lite';
import { useContext, useEffect, useRef } from 'react';
import { UsersContext } from '../../contexts/Users';

// records that the logged in user has opened an item, and has seen anything new while it is open
const MarkItemChecked = observer(
  ({ student, itemId, collection, isOpen = true }) => {
    const usersStore = useContext(UsersContext);
    const viewer = usersStore.getLoggedInUser();
    const hasUpdates = student.private.hasUpdatesForUser(
      itemId,
      collection,
      viewer
    );

    const isMarked = useRef(false);

    useEffect(() => {
      if (!isOpen) {
        isMarked.current = false;
      } else if (hasUpdates || !isMarked.current) {
        isMarked.current = true;
        student.private.markItemChecked(itemId, collection, viewer.id);
      }
    }, [isOpen, hasUpdates, student, itemId, collection, viewer.id]);

    return null;
  }
);

export default MarkItemChecked;
